import IndigoServiceClient from 'communication/IndigoServiceClient';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';
import { HolidaysRequest } from 'widgets/corpActions/api/HolidaysRequest';
import { HolidaysResponse } from 'widgets/corpActions/api/HolidaysResponse';

export async function holidaysSearch(
    indigoServiceClient: IndigoServiceClient,
    request: HolidaysRequest,
    options: ApiRequestOptions
): Promise<HolidaysResponse> {
    const {
        symbols,
        symbology,
        mics,
        types,
        flags,
        countries,
        dateSearchType,
        lookbackPeriod,
        lookforwardPeriod,
        limit,
    } = request;

    const formData = new FormData();
    formData.append('symbols', symbols);
    formData.append('symbology', symbology);
    if (mics) {
        formData.append('mics', mics);
    }
    if (types) {
        formData.append('types', types);
    }
    if (flags) {
        formData.append('flags', flags);
    }
    if (countries) {
        formData.append('countries', countries);
    }
    formData.append('dateSearchType', dateSearchType);
    if (limit !== undefined) {
        formData.append('limit', limit.toString());
    }
    if (lookbackPeriod) {
        formData.append('lookbackPeriod', lookbackPeriod);
    }
    if (lookforwardPeriod) {
        formData.append('lookforwardPeriod', lookforwardPeriod);
    }

    const url = 'holiday/search';

    return await IndigoApiError.runHandlingErrorsAsync(
        `Holiday Search`,
        async () => {
            return await indigoServiceClient.postFormData<HolidaysResponse>(
                url,
                formData,
                options
            );
        }
    );
}
